const video = {
	init(switcher) {
		if (switcher && document.querySelector('.video')) {
			console.log("présence d'un module video");
			
			this.youtube.addYTscript();
			
			// youtube
			this.youtube.init(); //
		}
	},

	youtube: {
		init() {
			// this.videosYt = document.querySelectorAll('.video.video__yt');

			document.addEventListener('click', (e) => {
				// document.querySelector('.optanon-category-C0005').setAttribute('type', 'script/javascript');


				let playerVideo = e.target.closest('.video.video__yt');
		
				if(playerVideo){
						this.start(playerVideo);
				}
				
			}, true);
		},

		start(container) {
			
			let playerIsIframe = false;
			let playerWrapper = container.querySelector('.video__video');
			
			if(!playerIsIframe){
				
				if(container.querySelector('.video__button')){
					container.querySelector('.video__button').remove();
				}
				
				let player = new window.YT.Player( playerWrapper , {
					videoId: container.dataset.ytId,
					events: {
						onReady: onPlayerReady,
						// onStateChange: onPlayerStateChange
					}
				});
	
				function onPlayerReady(event) {
					event.target.playVideo();
				}
	
				var done = false;
				

				console.dir( container)

				

				playerIsIframe = true;
			}
		
			
		
		},
		addYTscript() {
			// 2. This code loads the IFrame Player API code asynchronously.
			var tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}
	}
};

export default video;
